import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './Components/home';
import Login from './Components/Login';
import Signup from './Components/Signup';
import LoggedOutHome from './Components/LoggedOutHome';
import PrivacyPolicy from './Components/PrivacyPolicy';
import TermsOfService from './Components/TermsOfService';
import CookiePolicy from './Components/CookiePolicy';
import About from './Components/About';
import Contact from './Components/Contact';
import Documentation from './Components/Documentation';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LoggedOutHome />} />
        <Route path="/home" element={<Home />} />
        <Route path='/login' element={<Login />} />
        <Route path='/signup' element={<Signup />} />
        <Route path='/privacy' element={<PrivacyPolicy />} />
        <Route path='/terms' element={<TermsOfService />} />
        <Route path='/cookies' element={<CookiePolicy />} />
        <Route path='/about' element={<About/>} />
        <Route path='/contact' element={<Contact/>} />
        <Route path='/docs' element={<Documentation />} />
        <Route path='/*' element={
              <div className='page-not-found'>
                <div className="not-found-content">
                  <h1 className="not-found-code">404</h1>
                  <h3 className="not-found-title">Page Not Found</h3>
                  <p className="not-found-message">Oops! The page you're looking for doesn't exist or has been moved.</p>
                  <button className="not-found-btn" onClick={() => window.location.href = '/'}>
                    <i className="bi bi-house-door me-2"></i>
                    Back to Home
                  </button>
                </div>
              </div>
            } />
      </Routes>
    </div>
  );
}

export default App;
